import { FormulaUpdateBase } from '../models/formula.model';

export const formulaUpdateKeys: (keyof FormulaUpdateBase)[] = [
    'id',
    'name',
    'send_start',
    'send_stop',
    'send_start_date',
    'send_stop_date',
    'is_controlled_message',
    'override_provider_frequency_limits',
    'send_to_unsubscribed',
    'audience_id',
    'tags',
    'compound_trigger_id',
    'cms_placeholder_filters',
    'timezone',
    'additional_metadata',
    'content_card_type',
    'formula_sequence_touchpoint_id',
    'labels',
    'reward_function_id',
];
